import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frTranslations from './langs/fr.json';
import enTranslations from './langs/en.json';
import ptTranslations from './langs/pt.json';

// Get stored language or default to 'fr'
const storedLang = localStorage.getItem('i18nextLng') || 'fr';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: frTranslations },
      en: { translation: enTranslations },
      pt: { translation: ptTranslations },
    },
    lng: storedLang,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;

export const allLangs = [
  { label: 'Français', value: 'fr', icon: '/img/flags/fr.png' },
  { label: 'English', value: 'en', icon: '/img/flags/en.png' },
  { label: 'Português', value: 'pt', icon: '/img/flags/pt.png' },
];

export const defaultLang = allLangs[0]; // French as default
